import { render, staticRenderFns } from "./WidgetOverview.vue?vue&type=template&id=4530821d&scoped=true"
import script from "./WidgetOverview.vue?vue&type=script&lang=js"
export * from "./WidgetOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4530821d",
  null
  
)

export default component.exports